import React from 'react';
import {BenefitTag} from '@bonprix/design-system';

export default function ProductCardBenefits({benefits}) {

    if (benefits && benefits.length > 0) {
        return (
            <div className={"product-card__benefits"}>
                {benefits.map((benefit, index) => {
                        return (
                            <BenefitTag
                                variant={benefit.displayType.toLowerCase()}
                                size="small"
                                key={index}
                            >
                                {benefit.name}
                            </BenefitTag>
                        );
                    }
                )}
            </div>);
    }
    return null;
}
